<template>
  <div class="widget-container">
    <div class="d-flex flex-column mb-1">
      <div class="drip-body-small color-noble-blue-500">
        {{ $t('dashboard.requestCallbackWidgetAdvPO.header') }}
      </div>
      <div class="spacing-4"></div>
      <div class="drip-h3 color-noble-blue-500">
        {{ $t('dashboard.requestCallbackWidgetAdvPO.title.line1') }} <br />
        {{ $t('dashboard.requestCallbackWidgetAdvPO.title.line2') }}
      </div>
      <div class="spacing-32"></div>
      <div class="drip-label color-noble-blue-500">
        {{ $t('dashboard.requestCallbackWidgetAdvPO.additionalNote.line1') }}
        <br />
        {{ $t('dashboard.requestCallbackWidgetAdvPO.additionalNote.line2') }}
      </div>
    </div>
    <div class="spacing-12"></div>
    <div
      class="d-flex justify-content-center"
      v-if="!callbackMessageSent"
      @click="sentCallback"
    >
      <action-button variant="solid" extraClass="px-2 w-100">
        <b-icon-arrow-repeat
          animation="spin"
          class="mr-3"
          v-if="callbackFulfilled"
        />
        <b-icon-telephone class="mr-3" v-else />
        {{ $t('dashboard.requestCallbackWidgetAdvPO.buttonText') }}
      </action-button>
    </div>
    <div class="success-message" v-if="callbackMessageSent === 'success'">
      <b-icon-check-circle
        font-scale="1.1"
        class="color-dark-green mr-3 align-self-start"
        scale="1.5"
      />
      <div>{{ $t('dashboard.requestCallbackWidgetAdvPO.successMessage') }}</div>
    </div>
    <div class="success-message error" v-if="callbackMessageSent === 'failed'">
      <b-icon-x-circle
        font-scale="1.1"
        class="mt-0 mt-md-1 mt-xl-0 mr-3 color-advanced-red"
        scale="1.5"
      />
      <div>{{ $t('dashboard.requestCallbackWidgetAdvPO.errorMessage') }}</div>
    </div>
  </div>
</template>
<script>
import {
  BIconTelephone,
  BIconCheckCircle,
  BIconXCircle,
  BIconArrowRepeat
} from 'bootstrap-vue'
import exportersService from '@/services/exporters'
import ActionButton from '@/components/common/ActionButton'

export default {
  data() {
    return {
      name: '',
      email: '',
      phone: '',
      callbackFulfilled: false,
      callbackMessageSent: false
    }
  },
  mounted() {
    exportersService
      .fetchExporterMetaData(this.$store.state.account.accountId, {
        include: ['relationship_manager']
      })
      .then((res) => {
        const manager = res.data.relationship_manager
        if (manager) {
          this.name = manager.name
          this.email = manager.email
          this.phone = manager.phone
        }
      })
  },
  methods: {
    sentCallback() {
      if (!this.callbackFulfilled) {
        this.$mpTrack(
          'Clicks "Request a callback" on the "Advance against Purchase Order!" tile'
        )
        const accountId = this.$store.state.account.accountId
        this.callbackFulfilled = true
        exportersService
          .requestAMCallback(accountId, {
            vars: {
              callback_type: 'po_alert'
            }
          })
          .then((res) => {
            if (res.data === 'Slack Alert Sent') {
              this.$mpTrack('Slack alert triggered succesfully', {
                callback_type: 'po_alert'
              })
              this.callbackMessageSent = 'success'
            }
            if (res.data !== 'Slack Alert Sent') {
              this.callbackMessageSent = 'failed'
            }
            this.callbackFulfilled = false
          })
          .catch((err) => {
            console.log(err)
            this.callbackMessageSent = 'failed'
            this.callbackFulfilled = false
          })
      }
    }
  },
  components: {
    ActionButton,
    BIconTelephone,
    BIconCheckCircle,
    BIconXCircle,
    BIconArrowRepeat
  }
}
</script>
<style lang="scss" scoped>
.widget-container {
  background: url('../../assets/images/common/adv-po-background.svg');
  background-size: cover;
  background-position: right;
  border-radius: 8px;
  padding: 24px;
  margin-bottom: 16px;
  .content {
    .header {
      color: $noble-blue-500;
      font-weight: 700;
      font-size: 20px;
      line-height: 23px;
    }
  }
  .sub-header {
    color: $noble-blue-500;
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
  }
  .manager-info {
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
  }
  .success-message {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-weight: 700;
    font-size: 12px;
    line-height: 14px;
    padding: 16px;
    color: $noble-blue-500;
    background: $spring-green-100;
    border: 1px solid $spring-green-600;
    border-radius: 8px;
    margin-top: 12px;
    &.error {
      background: $red-100;
      border: 1px solid $red-400;
      align-items: center;
    }
  }
}
</style>
